export enum StageType {
    CHALLENGE = "challenge",
    REDIRECT = "redirect",
    FINALIZE = "finalize",
    EXCEPTION = "exception",
}
